// Add your JS customizations here

document.addEventListener( 'DOMContentLoaded', () => {
	const nav = document.getElementById( 'siteNav' );
	const mobileToggle = nav ? nav.querySelector( '.aq-nav__mobile-toggle' ) : null;
	const mobilePanel = nav ? nav.querySelector( '.aq-nav__mobile-panel' ) : null;

	if ( nav ) {
		const closeAllSubmenus = ( scope = nav ) => {
			scope.querySelectorAll( '.menu-item-has-children.is-open' ).forEach( ( item ) => {
				item.classList.remove( 'is-open' );
				const toggle = item.querySelector( ':scope > .aq-nav__submenu-toggle' );
				if ( toggle ) {
					toggle.setAttribute( 'aria-expanded', 'false' );
				}
			} );
		};

		const setMobileOpen = ( shouldOpen ) => {
			if ( ! mobileToggle || ! mobilePanel ) {
				return;
			}
			nav.classList.toggle( 'is-mobile-open', shouldOpen );
			mobileToggle.classList.toggle( 'is-active', shouldOpen );
			mobileToggle.setAttribute( 'aria-expanded', shouldOpen ? 'true' : 'false' );
			mobileToggle.setAttribute( 'aria-label', shouldOpen ? 'Fermer le menu' : 'Ouvrir le menu' );
			mobilePanel.setAttribute( 'aria-hidden', shouldOpen ? 'false' : 'true' );
			if ( ! shouldOpen ) {
				closeAllSubmenus( mobilePanel );
			}
		};

		const setupSubmenuToggles = ( menu ) => {
			const parentItems = menu.querySelectorAll( '.menu-item-has-children' );
			parentItems.forEach( ( item ) => {
				const subMenu = item.querySelector( ':scope > .sub-menu' );
				if ( ! subMenu ) {
					return;
				}
				const parentLink = item.querySelector( ':scope > a' );

				let toggle = item.querySelector( ':scope > .aq-nav__submenu-toggle' );
				if ( ! toggle ) {
					toggle = document.createElement( 'button' );
					toggle.type = 'button';
					toggle.className = 'aq-nav__submenu-toggle';
					toggle.setAttribute( 'aria-label', 'Toggle submenu' );
					toggle.setAttribute( 'aria-expanded', 'false' );
					toggle.innerHTML = '<i class="fa-solid fa-chevron-down" aria-hidden="true"></i>';
					item.insertBefore( toggle, subMenu );
				}

				const handleSubmenuToggle = ( event ) => {
					event.preventDefault();
					event.stopPropagation();
					const isOpen = item.classList.contains( 'is-open' );
					closeAllSubmenus( menu );
					if ( ! isOpen ) {
						item.classList.add( 'is-open' );
						toggle.setAttribute( 'aria-expanded', 'true' );
					}
				};

				toggle.addEventListener( 'click', handleSubmenuToggle );

				if ( parentLink ) {
					parentLink.addEventListener( 'click', handleSubmenuToggle );
				}
			} );
		};

		nav.querySelectorAll( '.aq-nav__menu' ).forEach( setupSubmenuToggles );

		if ( mobileToggle && mobilePanel ) {
			mobileToggle.addEventListener( 'click', () => {
				const isOpen = nav.classList.contains( 'is-mobile-open' );
				setMobileOpen( ! isOpen );
			} );

			mobilePanel.addEventListener( 'click', ( event ) => {
				const link = event.target.closest( 'a' );
				if ( ! link || window.innerWidth > 991 ) {
					return;
				}
				setMobileOpen( false );
			} );

			window.addEventListener( 'resize', () => {
				if ( window.innerWidth > 991 ) {
					setMobileOpen( false );
				}
			} );
		}

		document.addEventListener( 'click', ( event ) => {
			if ( ! nav.contains( event.target ) ) {
				closeAllSubmenus();
				setMobileOpen( false );
			}
		} );

		document.addEventListener( 'keydown', ( event ) => {
			if ( event.key === 'Escape' ) {
				closeAllSubmenus();
				setMobileOpen( false );
			}
		} );
	}

	if ( nav ) {
		let lastScrollY = window.scrollY;
		window.addEventListener(
			'scroll',
			() => {
				const currentY = window.scrollY;
				const scrollingUp = currentY < lastScrollY;
				lastScrollY = currentY;
				if ( scrollingUp && currentY > 10 ) {
					nav.classList.add( 'nav-solid' );
				} else {
					nav.classList.remove( 'nav-solid' );
				}
			},
			{ passive: true }
		);
	}

	const setupCarousel = ( block ) => {
		const viewport = block.querySelector( '.aq-carousel-viewport' );
		const prevButton = block.querySelector( '.aq-carousel-prev' );
		const nextButton = block.querySelector( '.aq-carousel-next' );
		if ( ! viewport || ! prevButton || ! nextButton ) {
			return;
		}

		let track = viewport.querySelector( '.carousel-track' );
		if ( ! track ) {
			track = document.createElement( 'div' );
			track.className = 'carousel-track';
			while ( viewport.firstChild ) {
				track.appendChild( viewport.firstChild );
			}
			viewport.appendChild( track );
		}

		let currentIndex = 0;
		let itemWidth = 0;
		let maxIndex = 0;

		const update = () => {
			track.style.transform = `translateX(${-Math.round( currentIndex * itemWidth )}px)`;
			prevButton.disabled = currentIndex <= 0;
			nextButton.disabled = currentIndex >= maxIndex;
		};

		const recalc = () => {
			const first = track.children[ 0 ];
			if ( ! first ) {
				return;
			}
			let gap = 0;
			if ( track.children.length > 1 ) {
				const rect1 = first.getBoundingClientRect();
				const rect2 = track.children[ 1 ].getBoundingClientRect();
				gap = Math.max( 0, rect2.left - ( rect1.left + rect1.width ) );
			}
			itemWidth = Math.round( first.getBoundingClientRect().width + gap );
			const visible = Math.max( 1, Math.floor( viewport.clientWidth / itemWidth ) );
			maxIndex = Math.max( 0, track.children.length - visible );
			currentIndex = Math.min( currentIndex, maxIndex );
			update();
		};

		prevButton.addEventListener( 'click', () => {
			currentIndex = Math.max( 0, currentIndex - 1 );
			update();
		} );
		nextButton.addEventListener( 'click', () => {
			currentIndex = Math.min( maxIndex, currentIndex + 1 );
			update();
		} );

		window.addEventListener( 'resize', recalc );
		setTimeout( recalc, 0 );
	};

		document.querySelectorAll( '.aq-carousel-block' ).forEach( setupCarousel );

		const setupCarouselHookMarquee = () => {
			const hookHeadings = document.querySelectorAll( '.aq-carousel-block > .flex.justify-between.items-center h2' );
			hookHeadings.forEach( ( heading ) => {
				heading.classList.add( 'aq-carousel-hook' );

				let textNode = heading.querySelector( '.aq-carousel-hook-text' );
				if ( ! textNode ) {
					textNode = document.createElement( 'span' );
					textNode.className = 'aq-carousel-hook-text';
					textNode.textContent = heading.textContent.trim();
					heading.textContent = '';
					heading.appendChild( textNode );
				}

				heading.classList.remove( 'is-marquee' );
				heading.style.removeProperty( '--aq-hook-marquee-distance' );
				heading.style.removeProperty( '--aq-hook-marquee-duration' );

				if ( window.innerWidth > 767 ) {
					return;
				}

				const overflow = textNode.scrollWidth - heading.clientWidth;
				if ( overflow <= 2 ) {
					return;
				}

				heading.classList.add( 'is-marquee' );
				heading.style.setProperty( '--aq-hook-marquee-distance', `${overflow}px` );
				const duration = Math.max( 6, Math.round( overflow / 18 ) );
				heading.style.setProperty( '--aq-hook-marquee-duration', `${duration}s` );
			} );
		};

		setupCarouselHookMarquee();
		window.addEventListener( 'resize', setupCarouselHookMarquee );

	const setupTrainingLayout = ( layout ) => {
		if ( ! layout || layout.dataset.trainingReady === 'true' ) {
			return;
		}

		const slides = Array.from( layout.querySelectorAll( '.training-carousel .training-slide' ) );
		const dotsContainer = layout.querySelector( '.training-carousel .training-dots' );
		const accordionItems = Array.from( layout.querySelectorAll( '.training-accordion .training-item' ) );

		let activeIndex = 0;
		const dots = [];

		const normalizeIndex = ( index ) => {
			if ( ! slides.length ) {
				return 0;
			}
			if ( index < 0 ) {
				return 0;
			}
			if ( index >= slides.length ) {
				return slides.length - 1;
			}
			return index;
		};

		const updateSlides = ( index ) => {
			if ( ! slides.length ) {
				return;
			}

			activeIndex = normalizeIndex( index );
			slides.forEach( ( slide, slideIndex ) => {
				const isActive = slideIndex === activeIndex;
				slide.classList.toggle( 'active', isActive );
				slide.setAttribute( 'data-slide-index', `${slideIndex}` );
				slide.setAttribute( 'aria-hidden', isActive ? 'false' : 'true' );
			} );

			dots.forEach( ( dot, dotIndex ) => {
				const isActive = dotIndex === activeIndex;
				dot.classList.toggle( 'active', isActive );
				dot.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
			} );
		};

		const updateAccordion = ( openIndex ) => {
			if ( ! accordionItems.length ) {
				return;
			}

			accordionItems.forEach( ( item, itemIndex ) => {
				const trigger = item.querySelector( '.training-trigger' );
				const panel = item.querySelector( '.training-panel' );
				const shouldOpen = itemIndex === openIndex;

				item.classList.toggle( 'open', shouldOpen );
				if ( trigger ) {
					trigger.setAttribute( 'aria-expanded', shouldOpen ? 'true' : 'false' );
				}
				if ( panel ) {
					panel.style.maxHeight = shouldOpen ? `${panel.scrollHeight}px` : '0px';
				}
			} );

			if ( slides.length ) {
				updateSlides( openIndex );
			}
		};

		if ( dotsContainer ) {
			dotsContainer.innerHTML = '';
			slides.forEach( ( _slide, slideIndex ) => {
				const dot = document.createElement( 'button' );
				dot.type = 'button';
				dot.className = 'training-dot';
				dot.setAttribute( 'data-dot-index', `${slideIndex}` );
				dot.setAttribute( 'aria-label', `Image ${slideIndex + 1}` );
				dot.setAttribute( 'role', 'tab' );
				dot.addEventListener( 'click', () => {
					if ( accordionItems.length ) {
						updateAccordion( Math.min( slideIndex, accordionItems.length - 1 ) );
						return;
					}
					updateSlides( slideIndex );
				} );
				dotsContainer.appendChild( dot );
				dots.push( dot );
			} );
		}

		accordionItems.forEach( ( item, itemIndex ) => {
			const trigger = item.querySelector( '.training-trigger' );
			if ( ! trigger ) {
				return;
			}
			trigger.addEventListener( 'click', () => updateAccordion( itemIndex ) );
		} );

		const preOpenIndex = accordionItems.findIndex( ( item ) => item.classList.contains( 'open' ) );
		if ( accordionItems.length ) {
			updateAccordion( preOpenIndex >= 0 ? preOpenIndex : 0 );
		} else if ( slides.length ) {
			updateSlides( 0 );
		}

		window.addEventListener( 'resize', () => {
			const currentOpen = accordionItems.findIndex( ( item ) => item.classList.contains( 'open' ) );
			if ( currentOpen >= 0 ) {
				updateAccordion( currentOpen );
			}
		} );

		layout.dataset.trainingReady = 'true';
	};

	document.querySelectorAll( '.training-layout' ).forEach( setupTrainingLayout );

	const contactToggle = document.getElementById( 'contactToggle' );
	const contactPopup = document.getElementById( 'contactPopup' );
	const contactClose = document.getElementById( 'contactClose' );
	const firstField = document.querySelector( '#contactPopupForm input, #contactPopupForm textarea' );

	if ( contactPopup && contactClose ) {
		const openPopup = () => {
			if ( contactToggle ) {
				contactToggle.classList.add( 'open' );
				contactToggle.setAttribute( 'aria-expanded', 'true' );
			}
			contactPopup.classList.add( 'open' );
			contactPopup.setAttribute( 'aria-hidden', 'false' );
			if ( firstField ) {
				setTimeout( () => firstField.focus(), 220 );
			}
		};

		const closePopup = () => {
			if ( contactToggle ) {
				contactToggle.classList.remove( 'open' );
				contactToggle.setAttribute( 'aria-expanded', 'false' );
			}
			contactPopup.classList.remove( 'open' );
			contactPopup.setAttribute( 'aria-hidden', 'true' );
		};

		if ( contactToggle ) {
			contactToggle.addEventListener( 'click', () => {
				if ( contactPopup.classList.contains( 'open' ) ) {
					closePopup();
					return;
				}
				openPopup();
			} );
		}

		contactClose.addEventListener( 'click', closePopup );

		document.addEventListener( 'click', ( event ) => {
			if ( ! contactPopup.classList.contains( 'open' ) ) {
				return;
			}
			if ( contactPopup.contains( event.target ) || ( contactToggle && contactToggle.contains( event.target ) ) ) {
				return;
			}
			closePopup();
		} );

		document.addEventListener( 'keydown', ( event ) => {
			if ( event.key === 'Escape' && contactPopup.classList.contains( 'open' ) ) {
				closePopup();
			}
		} );
	}
} );
